import { render, staticRenderFns } from "./SlaTeam.vue?vue&type=template&id=18d230a7&scoped=true&"
import script from "./SlaTeam.vue?vue&type=script&lang=js&"
export * from "./SlaTeam.vue?vue&type=script&lang=js&"
import style0 from "./SlaTeam.vue?vue&type=style&index=0&id=18d230a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d230a7",
  null
  
)

export default component.exports